import { createContext } from 'react';

/**
 * @type {React.Context<{
 *  connect: (connectData?: object, connectFunction?: (store: import('utils/types').EcommPlatformSource, queryData: object) => {}) => void,
 *  isConnecting: boolean,
 *  referrer: string,
 *  trialPeriod: string,
 *  isError: boolean,
 *  errorMessage: string
 * }>}
 */
export const ConnectFormContext = createContext();
